module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAApUlEQVQokZ2SsQ3CMBBFnyMqBqBkA2ZIzQqhR4KNGIANYIJQMgMSFBkAUSKZIv/EBeGLlC9Zvn/PJ1t3TnW9zvRK2s0/gCVfDXj1k7R41FdMU54F8AIsSjAq3AQsfGoDbEvQCrNWK78DjsBB+Ub51s5a4U2rk38Cb8deijt5kubo222608/xHwubswfmJRgVngOWo66egOuUG1cM/6pX8uPAxaP+Aw78JkNqhu+IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/16c.png
// module id = WxHs
// module chunks = 64